import { Link } from "@fluentui/react-components";
import * as React from "react";
/**
 * Component which renders a secure link which always has target and rel attribute set to noopener noreferrer
 */ export function SecureLink(props) {
    // Inline is default true since all links in Evo should be underlined
    const { href, className, ariaLabel, children, inline = true } = props;
    return /*#__PURE__*/ React.createElement(Link, {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        className: className,
        "aria-label": ariaLabel,
        inline: inline
    }, children);
}
